import { env } from './env'
import { convertToString } from './string'

let level = 0
const levelArray = ['debug', 'info', 'warn', 'error', 'none']

export function setLogLevel(logLevel: 'debug' | 'info' | 'warn' | 'error' | 'none'): void {
  level = levelArray.indexOf(logLevel)
}

function isDebugEnable(): boolean {
  return level <= 0
}

function isInfoEnable(): boolean {
  return level <= 1
}

function isWarnEnable(): boolean {
  return level <= 2
}

function isErrorEnable(): boolean {
  return level <= 3
}

export function debug(...data: any[]): void {
  if (isDebugEnable()) {
    console.info(['[DEBUG] ', ...data].map((item) => convertToString(item)).join(''))
  }
}

export function info(...data: any[]): void {
  if (isInfoEnable()) {
    console.info(['[INFO] ', ...data].map((item) => convertToString(item)).join(''))
  }
}

export function warn(...data: any[]): void {
  if (isWarnEnable()) {
    console.warn(['[WARN] ', ...data].map((item) => convertToString(item)).join(''))
  }
}

export function error(...data: any[]): void {
  if (isErrorEnable()) {
    console.error(
      ['[ERROR] ', ...data]
        .map((item, index) => {
          if (item instanceof Error) {
            return (index > 1 ? '\n' : '') + item.stack
          } else {
            return convertToString(item)
          }
        })
        .join('')
    )
  }
}

setLogLevel(env.PT_LOG_LEVEL || 'info')
